/* eslint-disable max-len */
/**
 * Module dependencies
 */
const React = require('react');
const PropTypes = require('prop-types');
const Head = require('react-declarative-head');
const Style = require('nordic/style');
const Script = require('nordic/script');
const injectI18n = require('nordic/i18n/injectI18n');
const PageContainer = require('../../components/PageContainer');
const NewsDetail = require('../../components/DevNews/components/NewsDetail');
const FeedbackProvider = require('../../../providers/contextProvider');
const { NewsListContextProvider } = require('../../../providers/newsListContextProvider');

const View = (props) => {
  const { platform, lang, i18n, newsContent, actualUrl, cookieFeedback, deviceType } = props;

  return (
    <FeedbackProvider>
      <PageContainer
        {...props}
        hideSearch
        hideSidebar
        footerClassNames="dev-news-detail"
        state={props}
      >
        <Head>
          <title>{i18n.gettext('Noticias - Mercado Pago Developers')}</title>
        </Head>
        <Style href="dev-news-detail-styles.css" />
        <Script src="dev-news-detail.js" priority={13} />
        <NewsListContextProvider
          lang={lang}
          i18n={i18n}
          platform={platform}
          actualUrlPath={actualUrl?.path}
        >
          <NewsDetail
            news={newsContent}
            cookieFeedback={cookieFeedback}
            deviceType={deviceType}
          />
        </NewsListContextProvider>
      </PageContainer>
    </FeedbackProvider>
  );
};

View.propTypes = {
  i18n: PropTypes.shape({
    gettext: PropTypes.func.isRequired,
  }).isRequired,
  platform: PropTypes.shape({
    siteId: PropTypes.string.isRequired,
  }).isRequired,
  actualUrl: PropTypes.shape({
    host: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    fullPath: PropTypes.string.isRequired,
  }).isRequired,
  lang: PropTypes.string.isRequired,
  assetsPath: PropTypes.string.isRequired,
  deviceType: PropTypes.string.isRequired,
};

/**
 * Inject i18n context as props into View.
 */
module.exports = injectI18n(View);
